// Simple wrapper around browser fetch for SWR
import fetch from 'cross-fetch'
import { spektrixApiUrl, fetchOptions } from './config'

const SpektrixFetcher = url =>
  fetch(`${spektrixApiUrl}${url}`, fetchOptions).then(res => res.json())

export default SpektrixFetcher
